/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'arrow': {
    width: 20,
    height: 34,
    viewBox: '0 0 20 34',
    data: '<path pid="0" d="M19.707 10.707a1 1 0 01-1.414 0L11 3.414V33a1 1 0 11-2 0V3.414l-7.293 7.293A1 1 0 01.293 9.293l9-9 .01-.01c.02-.02.041-.038.063-.056l.038-.028.04-.03L9.49.14l.04-.023.045-.022.043-.02.045-.016.048-.017.045-.012.05-.012.052-.008.044-.006a1.006 1.006 0 01.198 0c.015.001.03.004.044.006l.052.008.05.012.045.012.048.017.045.016.043.02.046.022.039.023.044.028c.014.009.028.02.041.03l.038.028c.022.018.043.038.064.058l.01.008 9 9a1 1 0 010 1.414z" _fill="#0B2C62"/>'
  }
})
